import { BasicResponse } from "../../../responses/basicResponses";

export async function updateAllTypes<T>(
    types: T[],
    updateFn: (type: T) => Promise<BasicResponse>,
): Promise<BasicResponse> {
    const results = await Promise.all(types.map(updateFn));
    const failed = results
        .map((x, i) => (!x.isSuccess ? i : null))
        .filter((x): x is number => x !== null);

    if (failed.length > 0) {
        return {
            isSuccess: false,
            message: `Failed to update ${failed.length} type(s).`,
        };
    }
    return { isSuccess: true, message: null };
}